import { toast } from "react-toastify";
import { callApi } from "../ApiHelper/ApiHelper";
import { apiUrl } from "../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../components/comman/MainFilterHandler";

export default function ExportDataHandler(data, fileNameFromApiResponce = false) {
  let options = {
    method: "GET",
  };

  const { month, ...restData } = data || {};
  let queryString = MainFilterHandler(restData);
  if (month) {
    queryString = `${queryString}${queryString ? "&" : ""}month=${month}`;
  }
  const API = `${apiUrl?.get_export_data}${queryString}`;

  callApi(API, options).then((response) => {
    if (response?.status === true && response?.data) {

      if (fileNameFromApiResponce) {
        const fileName = response.data.substring(response.data.lastIndexOf('/') + 1);
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", data?.exportDataType);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } else {
      toast.error(response?.message || "Failed to export data");
    }
  });
}


